import * as React from "react";
import { forwardRef } from "react";
const SvgCustomers = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4C9.51471 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51471 13 12 13Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M21 28H3V26C3 23.6131 3.94821 21.3239 5.63604 19.636C7.32387 17.9482 9.61305 17 12 17C14.3869 17 16.6761 17.9482 18.364 19.636C20.0518 21.3239 21 23.6131 21 26V28Z",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M20 4C21.1935 4 22.3381 4.47411 23.182 5.31802C24.0259 6.16193 24.5 7.30653 24.5 8.5C24.5 9.69347 24.0259 10.8381 23.182 11.682C22.3381 12.5259 21.1935 13 20 13",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23.2 17.38C24.9037 18.0281 26.3704 19.1782 27.4061 20.6782C28.4418 22.1781 28.9976 23.9572 29 25.78V28H26",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgCustomers);
export default ForwardRef;
